import { computed, getCurrentInstance } from 'vue'

export const useBaseLayout = () => {
  const instance = getCurrentInstance()
  const proxy = instance.proxy
  const route = computed(() => proxy.$route)

  const cacheViews = computed(() => {
    return proxy.$store.state.cacheView.cacheViews
  })

  const isKeepAlivePage = computed(() => {
    return route.value.meta.keepAlive === true
  })

  const routeCacheKey = computed(() => {
    const currentRoute = route.value
    const cacheKey = currentRoute.meta.cacheKey

    if (typeof cacheKey === 'function') {
      return cacheKey(currentRoute)
    }

    if (cacheKey === 'fullPath') {
      return currentRoute.fullPath
    }

    // 未显式配置 cacheKey 时返回 undefined，让 Vue 自行复用组件实例。
    // 若默认返回 route.name，嵌套布局的外层 router-view 会随叶子路由名变化，
    // 导致 TabbarLayout 及其子页面被反复销毁/重建，触发重复请求。
    return cacheKey
      ? currentRoute.name || currentRoute.path
      : undefined
  })

  return {
    cacheViews,
    isKeepAlivePage,
    routeCacheKey
  }
}
